import React, { useRef, useEffect } from "react";
import { RegionContext } from "../contexts";
import "../assets/styles/slider.sass";
import Utility from "../Utility";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
const Slider = ({ content }) => {
  const slider = Utility.getSlider(content);
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const breakpoints = {
    650: {
      slidesPerView: 2,
    },
    875: {
      slidesPerView: 3,
    },
    1100: {
      slidesPerView: 4,
    },
    1310: {
      slidesPerView: 5,
    },
  };
  const filteredBreakpoints = Object.fromEntries(
    Object.entries(breakpoints).filter(([, value]) => {
      return value.slidesPerView <= slider.length;
    })
  );
  const sliderElement = (
    <div className="ur-mini-slider">
      <div className="ur-mini-container">
        <button
          ref={prevButtonRef}
          className="ur-mini-slider-button-prev"
        ></button>
        <button
          ref={nextButtonRef}
          className="ur-mini-slider-button-next"
        ></button>
        {slider && slider.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: prevButtonRef.current,
              nextEl: nextButtonRef.current,
            }}
            slidesPerView={1}
            spaceBetween={16}
            breakpoints={filteredBreakpoints}
          >
            {slider.map((item, index) => {
              const channel = Utility.getChannel(content, item.channelId);
              return (
                <SwiperSlide key={index} className="ur-mini-slider-item">
                  <RegionContext.Consumer>
                    {(regionIndex) => {
                      return (
                        <Link to={item.url}>
                          <div
                            style={{ backgroundImage: `url(${item.imageUrl})` }}
                          >
                            <div
                              style={
                                channel && channel.colors && channel.colors.main
                                  ? {
                                      color: channel.colors.main,
                                    }
                                  : null
                              }
                            >
                              {item.title}
                              <div
                                style={
                                  channel &&
                                  channel.colors &&
                                  channel.colors.main
                                    ? {
                                        backgroundColor: channel.colors.main,
                                      }
                                    : null
                                }
                              ></div>
                            </div>
                          </div>
                        </Link>
                      );
                    }}
                  </RegionContext.Consumer>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : null}
      </div>
    </div>
  );
  return <>{sliderElement}</>;
};
export default Slider;
